import React, {useCallback, useEffect, useState} from 'react';
import usePortal from 'react-useportal';
import styles from './ModalUserAvatar.module.scss';

function ModalUserAvatar(props) {
    const {user, onClose} = props,
        {Portal} = usePortal(),
        [visible, setVisible] = useState(false),
        src = user.image_full_url ?? user.image_url ?? user.photo_url;

    useEffect(() => {
        setVisible(true);
    }, []);

    useEffect(() => {
        if (!visible) {
            const timeout = setTimeout(onClose, 550);
            return () => clearTimeout(timeout);
        }
    }, [visible]);

    const handleClose = useCallback(e => {
        setVisible(false);
        e.stopPropagation();
        e.preventDefault();
    }, []);

    return (
        <Portal>
            <div className={[styles.wrapper, visible ? styles.visible : ''].join(' ')} onClick={handleClose}>
                <div className={styles.avatar} style={{backgroundImage: `url(${src})`}} onClick={onClose}></div>
            </div>
        </Portal>
    );
}

export default ModalUserAvatar;
